export default "__VITE_ASSET__BIzwVSTI__"